<div class="backDrop center white" *ngIf="visible$ | async">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-center">{{ls.target.translations.catalog}} {{costMode ? 'Costs' : 'Prices'}}</h4>
            </div>
            <div class="modal-body">
                <dx-data-grid #serviceCatalogPricesGrid [dataSource]="mappedServices" [activeStateEnabled]="false" [showRowLines]="false" height="100%" (onCellPrepared)="onCellPrepared($event)" gridname>
                    <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>

                    <dxo-export [enabled]="false"></dxo-export>

                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

                    <dxo-search-panel [visible]="false"></dxo-search-panel>

                    <dxo-paging [pageSize]="25"></dxo-paging>

	                <dxo-pager [showPageSizeSelector]="false"></dxo-pager>

                    <dxi-column dataField="price" dataType="number" caption="{{ls.source.name}} {{costMode ? 'Costs' : 'Prices'}}" [allowEditing]="false" width="120px" cellTemplate="priceCellTemplate"></dxi-column>

                    <div *dxTemplate="let d of 'priceCellTemplate'" class="price-template-cell">
                        <div *ngIf="d.data.sourcePrices.length === 1" class="single-source-price-display">{{d.data.sourcePrices[0].price}}</div>

                        <div *ngIf="d.data.sourcePrices.length > 1" class="source-price-counter">({{d.data.sourcePrices.length}})</div>

                        <dx-lookup *ngIf="d.data.sourcePrices.length > 1" [dataSource]="d.data.sourcePrices" [(ngModel)]="d.data.price" valueExpr="price" displayExpr="price" [usePopover]="false" itemTemplate="priceItemTemplate">
                            <dxo-drop-down-options width="30vw" height="60vh"></dxo-drop-down-options>
                            <div *dxTemplate="let sourcePrice of 'priceItemTemplate'" class="price-item-cell">
                                <span class="price-tag">{{sourcePrice.price}}</span>{{sourcePrice.serviceName}}
                            </div>
                        </dx-lookup>
                    </div>

                    <dxi-column dataField="targetServiceName" dataType="string" caption="{{ls.target.translations.service}}" [allowEditing]="false"></dxi-column>

                    <dxi-column dataField="targetPrice" dataType="number" caption="{{ls.target.name}} {{costMode ? 'Cost' : 'Price'}}" [allowEditing]="false" width="120px" cellTemplate="targetPriceCellTemplate"></dxi-column>

                    <div *dxTemplate="let d of 'targetPriceCellTemplate'" class="target-price-template-cell">
                        <span class="price-field">
                            <i *ngIf="d.data.updating" class="far fa-spinner fa-spin"></i>
                            <i *ngIf="!d.data.updating && d.data.price === d.data.targetPrice" class="far fa-check success-color"></i>
                            <i *ngIf="!d.data.updating && d.data.price !== d.data.targetPrice" class="far fa-times failure-color"></i>
                            {{d.data.targetPrice}}
                        </span>
                        <button class="btn btn-warning post-button" [disabled]="updating || d.data.price === d.data.targetPrice" (click)="onPostClicked($event, d.data)">Post</button>
                    </div>
                </dx-data-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-default bottom-margin" (click)="exit()">Exit</button>
            </div>
        </div>
    </div>
</div>

<ng-template #loading>
	<div class="text-center loading-box m-3">
		<h6>Fetching picklists...</h6>
		<em class="far fa-4x fa-spin fa-spinner-third"></em>
	</div>
</ng-template>
